import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Directive, ElementRef, Inject, Input, PLATFORM_ID } from '@angular/core';
import { SwiperContainer } from 'swiper/element';
import { SwiperOptions } from 'swiper/types';

@Directive({
    selector: '[appSwiperDirective]',
    standalone: true,
})
export class SwiperDirective implements AfterViewInit {
    @Input() config?: SwiperOptions;

    private isBrowser = false;

    constructor(
        private el: ElementRef<SwiperContainer>,
        @Inject(PLATFORM_ID) private platformId: object,
    ) {
        this.isBrowser = isPlatformBrowser(platformId);
    }

    ngAfterViewInit(): void {
        if (this.isBrowser) {
            Object.assign(this.el.nativeElement, this.config);

            this.el.nativeElement.initialize();
        }
    }
}
